/* eslint-disable react/no-array-index-key */
import React, {ReactElement, useContext} from 'react';
import {cx} from '@emotion/css';
import DeviceContext, {Device} from '@fo/shared-providers/DeviceContext';

import Circle from './SVGCircles';
import {LayoutCircleConfig, LayoutCircleProps} from './LayoutSectionCircles.types';

import styles from './LayoutSectionCircles.styles';

interface Props {
  config: LayoutCircleConfig;
}

function LayoutSectionCircles({config}: Props): ReactElement | null {
  const {device} = useContext(DeviceContext);
  let circles: LayoutCircleProps[] = config.allDevices || [];
  // use device config
  switch (device) {
    case Device.MOBILE:
      circles = [...circles, ...(config.mobile || [])];
      break;

    case Device.TABLET:
      circles = [...circles, ...(config.tablet || [])];
      break;

    case Device.DESKTOP:
      circles = [...circles, ...(config.desktop || [])];
      break;

    default:
      return null;
  }

  // skip blank configs
  if (!circles || !circles.length) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {circles.map(({style, type, multiple, isSolid, imgUrl}, index) => {
        const circleClassName = cx(styles.circle(type, imgUrl));

        if (multiple) {
          return (
            <div className={cx(styles.multi)} style={style} key={`layoutCircle-multi-${index}`}>
              {[...Array(multiple.rows)].map((_, row) => (
                <div
                  key={`layoutCircle-multi-row-${row}`}
                  className={cx(styles.multiRow)}
                  style={{top: style.top, right: style.right, bottom: style.bottom, left: style.left}}
                >
                  {[...Array(multiple.columns)].map((__, col) => (
                    <div
                      key={`layoutCircle-multi-col-${row}-${col}`}
                      style={{...style, height: style.height || style.width}}
                    >
                      <Circle
                        style={{width: style.width}}
                        className={circleClassName}
                        isSolid={isSolid}
                        imgUrl={imgUrl}
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          );
        }

        return (
          <Circle
            key={`layoutCircle-${index}`}
            className={circleClassName}
            style={style}
            isSolid={isSolid}
            imgUrl={imgUrl}
          />
        );
      })}
    </>
  );
}

export default LayoutSectionCircles;
